module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/well/well_01.png";